import { createListenerMiddleware } from '@reduxjs/toolkit'
import { setAllAccessRights, resetAccessRights } from 'store/access-rights/slice'
import { determineAccessRights } from './utils'
import { selectIsProducerAccount, selectCurrentOpportunity } from 'store/contact/slice'
import { RootState } from 'store'

export const accessRightsListenerMiddleware = createListenerMiddleware()

// Listen to changes in contactStore.selected.billingContract
accessRightsListenerMiddleware.startListening({
  predicate: (_action, currentState, previousState) => {
    const prevState = previousState as RootState
    const currState = currentState as RootState

    // Check if selected.billingContract changed
    return prevState.contact.selected.billingContract !== currState.contact.selected.billingContract
  },
  effect: async (_action, listenerApi) => {
    const state = listenerApi.getState() as RootState
    const { selected, billingContracts } = state.contact

    // Check if there's a valid billing contract selected
    const hasValidContract = selected.billingContract && billingContracts[selected.billingContract]

    if (!hasValidContract) {
      // Reset access rights if no valid contract
      listenerApi.dispatch(resetAccessRights())
    } else {
      // Get the billing contract and related data
      const billingContract = billingContracts[selected.billingContract]
      const serviceContracts = billingContract.serviceContracts

      // Get additional data needed for access rights determination
      const isProducer = selectIsProducerAccount(state)
      const currentOpportunity = selectCurrentOpportunity(state)

      // Determine and set new access rights
      const newAccessRights = determineAccessRights({
        ...serviceContracts,
        isProducer,
        lastSettlementDate: billingContract.lastSettlementDate,
        currentOpportunity
      })

      listenerApi.dispatch(setAllAccessRights(newAccessRights))
    }
  }
})
